import { twApi } from '../api';
import {
  DeleteOtherExpenseAttachmentResponse,
  OtherExpenseAttachment,
  OtherExpenseAttachmentParams
} from './otherExpenseAttachment.model';

const otherExpenseAttachmentApi = twApi.injectEndpoints({
  endpoints: (builder) => ({
    getAttachmentsByExpenseId: builder.query<
      OtherExpenseAttachment[],
      { id: string; expenseId: string }
    >({
      query: ({ expenseId }) => ({
        url: `/v3/other-expenses/${expenseId}/attachments`,
        method: 'GET'
      }),
      transformResponse: (response: { data: OtherExpenseAttachment[] }) => response.data,
      providesTags: (result, error, expenseFile) => [
        { type: 'OtherExpensesAttachment', id: expenseFile.id }
      ]
    }),
    deleteOtherExpenseAttachments: builder.mutation<
      DeleteOtherExpenseAttachmentResponse,
      { ids: string[]; expenseId: string }
    >({
      query: ({ ids, expenseId }) => ({
        url: `v3/other-expenses/${expenseId}/attachments`,
        body: { ids },
        method: 'DELETE'
      }),
      transformResponse: (response: DeleteOtherExpenseAttachmentResponse) => response,
      invalidatesTags: (result, error, data) => [
        { type: 'OtherExpenses', id: data.expenseId },
        { type: 'OtherExpenses', id: 'OTHER_EXPENSES_LIST' },
        { type: 'Attachments', id: 'ATTACHMENTS_LIST' }
      ]
    }),
    uploadExpenseAttachments: builder.mutation<
      OtherExpenseAttachment[],
      { otherExpenseId: string; data: OtherExpenseAttachmentParams; token?: string }
    >({
      query: ({ otherExpenseId, data, token }) => {
        const formData = new FormData();

        data.attachments.forEach((attachment) => {
          formData.append('attachment', attachment);
        });

        let url = `/v3/other-expenses/${otherExpenseId}/attachments`;

        if (token) {
          url = `/v3/other-expenses/t/${token}/${otherExpenseId}/attachments`;
        }

        return {
          url,
          method: 'POST',
          body: formData,
          formData: true
        };
      },
      transformResponse: (response: { data: OtherExpenseAttachment[] }) => response.data,
      invalidatesTags: (result, error, data) => [
        { type: 'OtherExpenses', id: data.otherExpenseId },
        { type: 'OtherExpenses', id: 'OTHER_EXPENSES_LIST' },
        { type: 'Attachments', id: 'ATTACHMENTS_LIST' }
      ]
    })
  })
});

export const {
  useGetAttachmentsByExpenseIdQuery,
  useUploadExpenseAttachmentsMutation,
  useDeleteOtherExpenseAttachmentsMutation
} = otherExpenseAttachmentApi;
